// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { toggleFiltersStyles } from "@awc/App/Widgets/ToggleFilters/ToggleFiltersComponent";
import { color, xScreen } from "@awc/XDL/Utilities";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import { css } from "styled-components";

toggleFiltersStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
};

toggleFiltersStyles.accordionSection = {
    headerProps: {
        css: css`
            width: max-content;
            &&& button {
                gap: 12px;
            }
            ${({ expanded }: AccordionSectionHeaderProps) =>
                expanded &&
                css`
                    border-bottom: 0;
                `}

            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        `,
    },
    panelProps: {
        css: css`
            border: 1px solid ${color("common.black")};
        `,
    },
};
